import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SdvorButtonComponent } from '@sdvor/shared/ui';
import { LoginService } from '@user/data-access';

@Component({
  selector: 'sd-logout-from-all-devices',
  templateUrl: './logout-from-all-devices.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SdvorButtonComponent],
})
export class LogoutFromAllDevicesComponent {
  constructor(private loginService: LoginService) {}

  logout(): void {
    this.loginService.logout('all');
  }
}
